import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef, ContentChildren, ViewChild, Output, HostListener, Inject, PLATFORM_ID, ViewChildren, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';

function DropdownComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 7);
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_div_4_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.clear(); });
    ɵngcc0.ɵɵtext(5, "Clear");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 9);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_div_4_Template_div_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.apply(); });
    ɵngcc0.ɵɵtext(7, "Apply");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "open": a0 }; };
const _c1 = function (a0, a1) { return { "icon-open": a0, "icon-close": a1 }; };
const _c2 = ["*"];
function FiltersComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
const _c3 = function (a0, a1, a2, a3) { return [a0, a1, a2, a3]; };
function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_lib_base_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-base-item", 22);
} if (rf & 2) {
    const f_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const isFirst_r22 = ctx.first;
    const isLast_r23 = ctx.last;
    const isOdd_r24 = ctx.odd;
    const isEven_r25 = ctx.even;
    ɵngcc0.ɵɵnextContext();
    const _r18 = ɵngcc0.ɵɵreference(1);
    const filter_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("item item-", i_r21, "");
    ɵngcc0.ɵɵproperty("parentId", filter_r11.id)("dropdown", _r18)("id", f_r20.id)("name", f_r20.name)("slug", f_r20.id + "")("checked", f_r20.checked)("index", i_r21)("ngClass", ɵngcc0.ɵɵpureFunction4(11, _c3, isLast_r23 ? "last" : "", isFirst_r22 ? "first" : "", isOdd_r24 ? "odd" : "", isEven_r25 ? "even" : ""));
} }
const _c4 = function (a0, a1, a2, a3, a4, a5) { return [a0, a1, a2, a3, a4, a5]; };
function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-dropdown", 19, 20);
    ɵngcc0.ɵɵlistener("updateSelectedFilters", function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_Template_lib_dropdown_updateSelectedFilters_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(5); return ctx_r27.updateSelectedFilters($event); })("updateSelectedFiltersAndXOr", function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_Template_lib_dropdown_updateSelectedFiltersAndXOr_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(5); return ctx_r29.updateSelectedFiltersAndXOr($event); })("applyFilters", function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_Template_lib_dropdown_applyFilters_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r30 = ɵngcc0.ɵɵnextContext(5); return ctx_r30.applySelectedFilters(); })("clearFilters", function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_Template_lib_dropdown_clearFilters_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r31 = ɵngcc0.ɵɵnextContext(5); return ctx_r31.clearFilters(); });
    ɵngcc0.ɵɵtemplate(2, FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_lib_base_item_2_Template, 1, 16, "lib-base-item", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext();
    const i_r12 = ctx_r32.index;
    const filter_r11 = ctx_r32.$implicit;
    const isLast_r14 = ctx_r32.last;
    const isFirst_r13 = ctx_r32.first;
    const isOdd_r15 = ctx_r32.odd;
    const isEven_r16 = ctx_r32.even;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵclassMapInterpolate1("sns-dropdown-item sns-dropdown-item-", i_r12, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction6(10, _c4, filter_r11.children.length > 0 ? "show" : "disabled", ctx_r17.isMobileResolution ? "mobile" : "", isLast_r14 ? "last" : "", isFirst_r13 ? "first" : "", isOdd_r15 ? "odd" : "", isEven_r16 ? "even" : ""))("title", filter_r11.name)("icon", filter_r11.icon)("type", "classic")("operator", ctx_r17.filterOperation)("parentId", filter_r11.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", filter_r11.children);
} }
function FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_lib_dropdown_1_Template, 3, 17, "lib-dropdown", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filter_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filter_r11.children.length > 0);
} }
function FiltersComponent_ng_template_1_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_ng_template_1_ng_template_0_div_0_Template_div_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(3); return ctx_r33.openFilter($event); });
    ɵngcc0.ɵɵelement(2, "span", 9);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4, "Filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 10);
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵelementStart(7, "div", 12);
    ɵngcc0.ɵɵelement(8, "span", 13);
    ɵngcc0.ɵɵelementStart(9, "span", 14);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_ng_template_1_ng_template_0_div_0_Template_span_click_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r35 = ɵngcc0.ɵɵnextContext(3); return ctx_r35.closeFilter($event); });
    ɵngcc0.ɵɵelement(10, "span", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, FiltersComponent_ng_template_1_ng_template_0_div_0_ng_container_11_Template, 2, 1, "ng-container", 16);
    ɵngcc0.ɵɵelement(12, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.isFilterOpen ? "" : "hidden");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.filterWithChildren);
} }
function FiltersComponent_ng_template_1_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FiltersComponent_ng_template_1_ng_template_0_div_0_Template, 13, 2, "div", 6);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.filterWithChildren.length > 0);
} }
function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_lib_base_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-base-item", 22);
} if (rf & 2) {
    const f_r47 = ctx.$implicit;
    const i_r48 = ctx.index;
    const isFirst_r49 = ctx.first;
    const isLast_r50 = ctx.last;
    const isOdd_r51 = ctx.odd;
    const isEven_r52 = ctx.even;
    ɵngcc0.ɵɵnextContext();
    const _r45 = ɵngcc0.ɵɵreference(1);
    const filter_r38 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("item item-", i_r48, "");
    ɵngcc0.ɵɵproperty("parentId", filter_r38.id)("dropdown", _r45)("id", f_r47.id)("name", f_r47.name)("slug", f_r47.id + "")("checked", f_r47.checked)("index", i_r48)("ngClass", ɵngcc0.ɵɵpureFunction4(11, _c3, isLast_r50 ? "last" : "", isFirst_r49 ? "first" : "", isOdd_r51 ? "odd" : "", isEven_r52 ? "even" : ""));
} }
const _c5 = function (a0, a1, a2, a3, a4) { return [a0, a1, a2, a3, a4]; };
function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    const _r55 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-dropdown", 19, 20);
    ɵngcc0.ɵɵlistener("updateSelectedFilters", function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_Template_lib_dropdown_updateSelectedFilters_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r55); const ctx_r54 = ɵngcc0.ɵɵnextContext(5); return ctx_r54.updateSelectedFilters($event); })("updateSelectedFiltersAndXOr", function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_Template_lib_dropdown_updateSelectedFiltersAndXOr_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r55); const ctx_r56 = ɵngcc0.ɵɵnextContext(5); return ctx_r56.updateSelectedFiltersAndXOr($event); })("applyFilters", function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_Template_lib_dropdown_applyFilters_0_listener() { ɵngcc0.ɵɵrestoreView(_r55); const ctx_r57 = ɵngcc0.ɵɵnextContext(5); return ctx_r57.applySelectedFilters(); })("clearFilters", function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_Template_lib_dropdown_clearFilters_0_listener() { ɵngcc0.ɵɵrestoreView(_r55); const ctx_r58 = ɵngcc0.ɵɵnextContext(5); return ctx_r58.clearFilters(); });
    ɵngcc0.ɵɵtemplate(2, FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_lib_base_item_2_Template, 1, 16, "lib-base-item", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = ɵngcc0.ɵɵnextContext();
    const i_r39 = ctx_r59.index;
    const filter_r38 = ctx_r59.$implicit;
    const isLast_r41 = ctx_r59.last;
    const isFirst_r40 = ctx_r59.first;
    const isOdd_r42 = ctx_r59.odd;
    const isEven_r43 = ctx_r59.even;
    const ctx_r44 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵclassMapInterpolate1("sns-dropdown-item sns-dropdown-item-", i_r39, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(10, _c5, filter_r38.children.length > 0 ? "show" : "disabled", isLast_r41 ? "last" : "", isFirst_r40 ? "first" : "", isOdd_r42 ? "odd" : "", isEven_r43 ? "even" : ""))("title", filter_r38.name)("icon", filter_r38.icon)("type", "classic")("operator", ctx_r44.filterOperation)("parentId", filter_r38.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", filter_r38.children);
} }
function FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_lib_dropdown_1_Template, 3, 16, "lib-dropdown", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filter_r38 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filter_r38.children.length > 0);
} }
function FiltersComponent_ng_template_1_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵtemplate(3, FiltersComponent_ng_template_1_ng_template_1_div_0_ng_container_3_Template, 2, 1, "ng-container", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r36.filterWithChildren);
} }
function FiltersComponent_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FiltersComponent_ng_template_1_ng_template_1_div_0_Template, 4, 1, "div", 23);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.filterWithChildren.length > 0);
} }
function FiltersComponent_ng_template_1_ng_container_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r63 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 30);
    ɵngcc0.ɵɵelement(2, "span", 32);
    ɵngcc0.ɵɵelementStart(3, "img", 33);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_ng_template_1_ng_container_3_div_4_Template_img_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r63); const filterId_r61 = ctx.$implicit; const ctx_r62 = ɵngcc0.ɵɵnextContext(3); return ctx_r62.removeFilter(filterId_r61); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filterId_r61 = ctx.$implicit;
    const ctx_r60 = ɵngcc0.ɵɵnextContext(3);
    let tmp_0_0 = null;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", (tmp_0_0 = ctx_r60.idToNameFilterMap.get(filterId_r61)) == null ? null : tmp_0_0.name, ɵngcc0.ɵɵsanitizeHtml);
} }
function FiltersComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r65 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 27);
    ɵngcc0.ɵɵtext(2, "Applied filters");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 28);
    ɵngcc0.ɵɵtemplate(4, FiltersComponent_ng_template_1_ng_container_3_div_4_Template, 4, 1, "div", 16);
    ɵngcc0.ɵɵelementStart(5, "div", 29);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_ng_template_1_ng_container_3_Template_div_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r65); const ctx_r64 = ɵngcc0.ɵɵnextContext(2); return ctx_r64.clearAll(); });
    ɵngcc0.ɵɵelementStart(6, "div", 30);
    ɵngcc0.ɵɵtext(7, " Reset filter ");
    ɵngcc0.ɵɵelement(8, "img", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.selectedFilters);
} }
function FiltersComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FiltersComponent_ng_template_1_ng_template_0_Template, 1, 1, "ng-template", 3);
    ɵngcc0.ɵɵtemplate(1, FiltersComponent_ng_template_1_ng_template_1_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(3, FiltersComponent_ng_template_1_ng_container_3_Template, 9, 1, "ng-container", 5);
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(2);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isMobileResolution)("ngIfElse", _r6);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.selectedFilters && ctx_r2.selectedFilters.length > 0);
} }
const _c6 = function (a0) { return [a0]; };
function FiltersComponent_ng_template_3_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r70 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 38);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_ng_template_3_div_0_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r70); const ctx_r69 = ɵngcc0.ɵɵnextContext(3); return ctx_r69.selectFilter("click", "-1"); });
    ɵngcc0.ɵɵelementStart(1, "span", 39);
    ɵngcc0.ɵɵtext(2, "All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c6, ctx_r67.isAll ? "active" : ""));
} }
function FiltersComponent_ng_template_3_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r78 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 40);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_ng_template_3_div_0_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r78); const i_r72 = ctx.index; const filter_r71 = ctx.$implicit; const ctx_r77 = ɵngcc0.ɵɵnextContext(3); return ctx_r77.selectFilter("click" + i_r72, filter_r71); });
    ɵngcc0.ɵɵelementStart(1, "span", 39);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r71 = ctx.$implicit;
    const isFirst_r73 = ctx.first;
    const isLast_r74 = ctx.last;
    const isOdd_r75 = ctx.odd;
    const isEven_r76 = ctx.even;
    ɵngcc0.ɵɵpropertyInterpolate("id", filter_r71.id);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(3, _c5, filter_r71.checked ? "active" : "", isLast_r74 ? "last" : "", isFirst_r73 ? "first" : "", isOdd_r75 ? "odd" : "", isEven_r76 ? "even" : ""));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(filter_r71.name);
} }
function FiltersComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵtemplate(1, FiltersComponent_ng_template_3_div_0_span_1_Template, 3, 3, "span", 36);
    ɵngcc0.ɵɵtemplate(2, FiltersComponent_ng_template_3_div_0_span_2_Template, 3, 9, "span", 37);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r66.filterOperation != ctx_r66.and);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r66.filters);
} }
function FiltersComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FiltersComponent_ng_template_3_div_0_Template, 3, 2, "div", 34);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.filters.length > 0);
} }
class Filter {
    constructor() {
        this.checked = false;
    }
}
class FilterDropdown {
    constructor() {
        this.checked = false;
    }
}
class FilterValue {
}
class FilterValueChild {
}
class Query {
}
class Bool {
}
class Match {
}
class MatchCategory {
}
class JsonFilter {
}
class JsonFilterChild {
}
var FilterCategoryOperationEnum;
(function (FilterCategoryOperationEnum) {
    FilterCategoryOperationEnum["AND"] = "AND";
    FilterCategoryOperationEnum["OR"] = "OR";
    FilterCategoryOperationEnum["ANDxOR"] = "ANDxOR";
    FilterCategoryOperationEnum["ORxAND"] = "ORxAND";
})(FilterCategoryOperationEnum || (FilterCategoryOperationEnum = {}));
var CategoryOperationEnum;
(function (CategoryOperationEnum) {
    CategoryOperationEnum["AND"] = "AND";
    CategoryOperationEnum["OR"] = "OR";
})(CategoryOperationEnum || (CategoryOperationEnum = {}));
var LSK;
(function (LSK) {
    LSK["SELECTED_FILTERS"] = "selectedFilters";
    LSK["SELECTED_FILTERS_AND_X_OR"] = "selectedFiltersAndXOR";
})(LSK || (LSK = {}));

class FiltersService {
    constructor() { }
    createElasticQuery(categories, filterCategories, categoryOperation = CategoryOperationEnum.AND, filterOperation = FilterCategoryOperationEnum.AND) {
        let categoryMatchArray = new Array();
        let filterCategoryMatchArray = new Array();
        let categoryBool = new Bool();
        let filterCategoryBool = new Bool();
        let categoryQueryBool = new Query();
        let filterCategoryQueryBool = new Query();
        let mustArray = new Array();
        let bool = new Bool();
        let query = new Query();
        categories.forEach((elem) => {
            categoryMatchArray.push(FiltersService.createMatch(String(elem)));
        });
        switch (categoryOperation) {
            case CategoryOperationEnum.AND:
                categoryBool.must = categoryMatchArray;
                break;
            case CategoryOperationEnum.OR:
                categoryBool.should = categoryMatchArray;
                break;
            default:
                break;
        }
        categoryQueryBool.bool = categoryBool;
        mustArray.push(categoryQueryBool);
        if (filterOperation == FilterCategoryOperationEnum.AND || filterOperation == FilterCategoryOperationEnum.OR) {
            filterCategories.forEach((elem) => {
                filterCategoryMatchArray.push(FiltersService.createMatch(String(elem)));
            });
            if (filterCategoryMatchArray.length > 0) {
                switch (filterOperation) {
                    case FilterCategoryOperationEnum.AND:
                        filterCategoryBool.must = filterCategoryMatchArray;
                        break;
                    case FilterCategoryOperationEnum.OR:
                        filterCategoryBool.should = filterCategoryMatchArray;
                        break;
                    default:
                        break;
                }
                filterCategoryQueryBool.bool = filterCategoryBool;
                mustArray.push(filterCategoryQueryBool);
            }
        }
        else {
            let filterOperatorA = 'AND';
            let filterOperatorB = 'OR';
            if (filterOperation == FilterCategoryOperationEnum.ORxAND) {
                filterOperatorA = 'OR';
                filterOperatorB = 'AND';
            }
            let twoLevelFilter = filterCategories;
            if (twoLevelFilter.length > 0) {
                let jsonArray = new Array();
                twoLevelFilter.forEach((elem) => {
                    let filterCategoryJSONQueryBoolChild = new Query();
                    let filterCategoryJsonBool = new Bool();
                    let filterCategoryJsonMatchArray = new Array();
                    if (elem.children.length > 0) {
                        elem.children.forEach((child) => {
                            filterCategoryJsonMatchArray.push(FiltersService.createMatch(String(child)));
                        });
                        if (filterOperatorB === 'AND') {
                            filterCategoryJsonBool.must = filterCategoryJsonMatchArray;
                        }
                        else {
                            filterCategoryJsonBool.should = filterCategoryJsonMatchArray;
                        }
                        filterCategoryJSONQueryBoolChild.bool = filterCategoryJsonBool;
                        jsonArray.push(filterCategoryJSONQueryBoolChild);
                    }
                });
                if (filterOperatorA === 'AND') {
                    filterCategoryBool.must = jsonArray;
                }
                else {
                    filterCategoryBool.should = jsonArray;
                }
                filterCategoryQueryBool.bool = filterCategoryBool;
                mustArray.push(filterCategoryQueryBool);
            }
        }
        bool.must = mustArray;
        query.bool = bool;
        return JSON.stringify(query);
    }
    static isTwoLevelMixOperation(operator) {
        return operator == FilterCategoryOperationEnum.ANDxOR || operator == FilterCategoryOperationEnum.ORxAND;
    }
    static createMatch(category) {
        let catMatch = new Match();
        let catCategory = new MatchCategory();
        catCategory['categories.externalId'] = category;
        catMatch.match = catCategory;
        return catMatch;
    }
}
FiltersService.ɵfac = function FiltersService_Factory(t) { return new (t || FiltersService)(); };
FiltersService.ɵprov = i0.ɵɵdefineInjectable({ factory: function FiltersService_Factory() { return new FiltersService(); }, token: FiltersService, providedIn: "root" });
FiltersService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FiltersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class BaseItemComponent {
    constructor() {
        this.checked = false;
    }
    toggle() {
        this.dropdown.onCheckboxToggle();
    }
    clear() {
        this.dropdown.clear();
    }
}
BaseItemComponent.ɵfac = function BaseItemComponent_Factory(t) { return new (t || BaseItemComponent)(); };
BaseItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BaseItemComponent, selectors: [["lib-base-item"]], inputs: { checked: "checked", id: "id", name: "name", slug: "slug", dropdown: "dropdown", index: "index", parentId: "parentId" }, decls: 3, vars: 6, consts: [[1, "checkbox", 3, "for"], ["type", "checkbox", 3, "id", "ngModel", "name", "value", "ngModelChange"], [3, "innerHTML"]], template: function BaseItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function BaseItemComponent_Template_input_ngModelChange_1_listener($event) { return ctx.checked = $event; })("ngModelChange", function BaseItemComponent_Template_input_ngModelChange_1_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", "check-" + ctx.index);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", "check-" + ctx.index)("ngModel", ctx.checked)("name", ctx.slug)("value", ctx.slug);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.name, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: [ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], styles: ["[_nghost-%COMP%]   .checkbox[_ngcontent-%COMP%]{width:100%;cursor:pointer;align-items:center;padding:12.5px 5px 12.5px 23px}[_nghost-%COMP%]   .checkbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{flex-shrink:0;margin-right:10px}"] });
BaseItemComponent.ctorParameters = () => [];
BaseItemComponent.propDecorators = {
    id: [{ type: Input }],
    name: [{ type: Input }],
    slug: [{ type: Input }],
    dropdown: [{ type: Input }],
    index: [{ type: Input }],
    parentId: [{ type: Input }],
    checked: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseItemComponent, [{
        type: Component,
        args: [{
                selector: 'lib-base-item',
                template: "<label [for]=\"'check-' + index\" class=\"checkbox\">\n  <input [id]=\"'check-' + index\"\n         [(ngModel)]=\"checked\"\n         (ngModelChange)=\"toggle()\"\n         type=\"checkbox\"\n         [name]=\"slug\"\n         [value]=\"slug\" /> <span [innerHTML]=\"name\"></span>\n</label>\n\n",
                styles: [":host .checkbox{width:100%;cursor:pointer;align-items:center;padding:12.5px 5px 12.5px 23px}:host .checkbox input{flex-shrink:0;margin-right:10px}\n"]
            }]
    }], function () { return []; }, { checked: [{
            type: Input
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], slug: [{
            type: Input
        }], dropdown: [{
            type: Input
        }], index: [{
            type: Input
        }], parentId: [{
            type: Input
        }] }); })();

class DropdownComponent {
    constructor(elemRef, cdr) {
        this.elemRef = elemRef;
        this.cdr = cdr;
        this.updateSelectedFilters = new EventEmitter();
        this.updateSelectedFiltersAndXOr = new EventEmitter();
        this.applyFilters = new EventEmitter();
        this.clearFilters = new EventEmitter();
        this.selectedFilters = [];
        this.selectedFiltersAndXOr = [];
        this.selectedValues = [];
        this.dropdown = false;
        this.counter = 0;
    }
    ngOnInit() {
        if (localStorage.getItem(LSK.SELECTED_FILTERS) === null) {
            localStorage.setItem(LSK.SELECTED_FILTERS, '[]');
        }
        else {
            this.selectedFilters = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS) || '[]');
        }
        if (localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) === null) {
            localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, '[]');
        }
        else {
            this.selectedFiltersAndXOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
        }
    }
    ngAfterViewInit() {
        this.baseItemComponent.forEach((baseItemComponent) => {
            if (this.selectedFilters.includes(baseItemComponent.id)) {
                baseItemComponent.checked = true;
                this.counter++;
            }
        });
        this.cdr.detectChanges();
    }
    onCheckboxToggle() {
        let counter = 0;
        let parentId = -1;
        this.selectedFilters = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS) || '[]');
        this.selectedFiltersAndXOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
        this.baseItemComponent.forEach((baseItemComponent) => {
            if (baseItemComponent.checked) {
                parentId = baseItemComponent.parentId;
                if (this.canAdd(baseItemComponent.id)) {
                    this.selectedFilters.push(baseItemComponent.id);
                    this.selectedValues.push(baseItemComponent.id);
                }
                counter++;
            }
            else {
                this.removeItem(baseItemComponent.id);
            }
        });
        if (FiltersService.isTwoLevelMixOperation(this.operator)) {
            let fv = new FilterValue();
            fv.id = parentId;
            fv.children = this.selectedValues;
            this.selectedFiltersAndXOr.push(fv);
        }
        this.counter = counter;
        this.cdr.markForCheck();
    }
    canAdd(filter) {
        for (const sf of this.selectedFilters) {
            if (sf === filter) {
                return false;
            }
        }
        return true;
    }
    apply() {
        console.log('Applay');
        localStorage.setItem(LSK.SELECTED_FILTERS, JSON.stringify(this.selectedFilters));
        if (FiltersService.isTwoLevelMixOperation(this.operator)) {
            this.andXORStorage();
            let filtersAndXOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
            this.updateSelectedFiltersAndXOr.emit(filtersAndXOr);
        }
        this.updateSelectedFilters.emit(this.selectedFilters);
        this.applyFilters.emit();
    }
    clear() {
        this.counter = 0;
        this.selectedFilters = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS) || '[]');
        this.baseItemComponent.forEach((baseItemComponent) => {
            baseItemComponent.checked = false;
            this.removeItem(baseItemComponent.id);
        });
        if (FiltersService.isTwoLevelMixOperation(this.operator)) {
            this.andXORStorage();
            let filtersAndXOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
            if (filtersAndXOr.length > 0) {
                filtersAndXOr.forEach((elem, index) => {
                    if (elem.id == this.parentId) {
                        filtersAndXOr.splice(index, 1);
                    }
                });
            }
            localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, JSON.stringify(filtersAndXOr));
            this.updateSelectedFiltersAndXOr.emit(filtersAndXOr);
        }
        this.updateSelectedFilters.emit(this.selectedFilters);
        this.clearFilters.emit(this.selectedFilters);
    }
    clearFilter(filter) {
        this.counter = 0;
        this.selectedFilters = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS) || '[]');
        if (this.baseItemComponent.length == 0 && this.selectedFilters.length > 0) {
            this.removeItem(filter);
        }
        else {
            this.baseItemComponent.forEach((baseItemComponent) => {
                if (filter && filter === baseItemComponent.id) {
                    baseItemComponent.checked = false;
                    this.removeItem(filter);
                }
            });
        }
        if (FiltersService.isTwoLevelMixOperation(this.operator)) {
            this.updateSelectedFiltersAndXOr.emit(this.selectedFiltersAndXOr);
        }
        this.updateSelectedFilters.emit(this.selectedFilters);
        return this.selectedFilters;
    }
    clearAllFilter() {
        this.counter = 0;
        this.selectedFilters = [];
        this.selectedFiltersAndXOr = [];
        this.selectedValues = [];
        this.baseItemComponent.forEach((baseItemComponent) => {
            baseItemComponent.checked = false;
        });
        localStorage.setItem(LSK.SELECTED_FILTERS, JSON.stringify(this.selectedFilters));
        localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, JSON.stringify(this.selectedFiltersAndXOr));
    }
    removeItem(id) {
        const i = this.selectedFilters.indexOf(id);
        if (i !== -1) {
            this.selectedFilters.splice(i, 1);
        }
        const j = this.selectedValues.indexOf(id);
        if (j !== -1) {
            this.selectedValues.splice(j, 1);
        }
        localStorage.setItem(LSK.SELECTED_FILTERS, JSON.stringify(this.selectedFilters));
    }
    toggleDropdown(event) {
        if (!this.elemRef.nativeElement.contains(event.target) ||
            event.target.className === 'button col-md-6' ||
            event.target.className.includes('open') ||
            event.target.className.includes('apply')) {
            this.dropdown = false;
        }
        else if (this.elemRef.nativeElement.contains(event.target)) {
            this.dropdown = true;
        }
    }
    andXORStorage() {
        let isParent = false;
        let filtersAndXOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
        filtersAndXOr.forEach((item, index, object) => {
            if (item.id == this.parentId) {
                isParent = true;
                item.children = this.selectedValues;
            }
        });
        if (isParent) {
            localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, JSON.stringify(filtersAndXOr));
            this.selectedFiltersAndXOr = filtersAndXOr;
        }
        else {
            localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, JSON.stringify(this.selectedFiltersAndXOr));
        }
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["lib-dropdown"]], contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BaseItemComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.baseItemComponent = _t);
    } }, viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BaseItemComponent, 1, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bic = _t.first);
    } }, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DropdownComponent_click_HostBindingHandler($event) { return ctx.toggleDropdown($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { title: "title", icon: "icon", type: "type", operator: "operator", parentId: "parentId" }, outputs: { updateSelectedFilters: "updateSelectedFilters", updateSelectedFiltersAndXOr: "updateSelectedFiltersAndXOr", applyFilters: "applyFilters", clearFilters: "clearFilters" }, ngContentSelectors: _c2, decls: 5, vars: 10, consts: [[1, "dropdown-wrapper", 3, "ngClass"], [1, "selected", 3, "ngClass"], [1, "name", 3, "innerHTML"], [1, "dropdown-icon", 3, "ngClass"], ["class", "dropdown", 4, "ngIf"], [1, "dropdown"], [1, "some"], [1, "button-wrapper", "p-0"], [1, "button", "col-6", "parentId", "clear", 3, "click"], [1, "button", "apply", "col-6", 3, "click"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DropdownComponent_div_4_Template, 8, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx.dropdown));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.title, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c1, ctx.dropdown, !ctx.dropdown));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dropdown);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], styles: [".sns-dropdown-item[_nghost-%COMP%]{border-radius:0;background-color:#fff;color:#000;border:1px solid #000000;margin-left:20px}.sns-dropdown-item.first[_nghost-%COMP%]{margin:0}.sns-dropdown-item.mobile.first[_nghost-%COMP%]{margin-left:20px}.sns-dropdown-item[_nghost-%COMP%]:not(.mobile)   .dropdown[_ngcontent-%COMP%]{box-shadow:0 0 10px #00000026;padding:10px 0 20px;background-color:#fff;position:absolute;width:auto;top:50px;left:0;z-index:9999999;min-width:250px}.sns-dropdown-item.mobile[_nghost-%COMP%]{border:solid .5px rgba(167,167,168,.75);border-top:0;border-right:0}.sns-dropdown-item.mobile[_nghost-%COMP%]   .dropdown-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start}.sns-dropdown-item.mobile[_nghost-%COMP%]   .dropdown-wrapper.classic[_ngcontent-%COMP%]{background:none;padding-right:0;padding-left:0;padding-bottom:0}.sns-dropdown-item.mobile[_nghost-%COMP%]   .dropdown-wrapper[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]{padding-bottom:15px}.sns-dropdown-item.mobile[_nghost-%COMP%]   .dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]{width:100%}.dropdown-wrapper[_ngcontent-%COMP%]{background-color:#fff;justify-content:center;align-items:center;position:relative;cursor:pointer;display:flex;height:100%;width:100%;padding:9px 20px}.dropdown-wrapper.classic[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]{background:url(/assets/arrow-down-black.svg) 95% center no-repeat}.dropdown-wrapper.classic[_ngcontent-%COMP%]   .selected.open[_ngcontent-%COMP%]{background:url(/assets/arrow-up-black.svg) 95% center no-repeat}.dropdown-wrapper[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]{justify-content:space-between;align-items:center;display:flex;height:31px;padding:6px 14px;width:100%;position:relative;z-index:0}.dropdown-wrapper[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:20px;width:20px}.dropdown-wrapper[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{line-height:1.5;letter-spacing:normal}.dropdown-wrapper[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]   .dropdown-icon[_ngcontent-%COMP%]{background-repeat:no-repeat;height:6px;width:8px}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .some[_ngcontent-%COMP%]{border-bottom:solid 1px rgba(0,0,0,.05);padding-left:14px}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .select-info[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding:2px 16px}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]{display:flex}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{text-align:center;padding:10px 16px}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .button.apply[_ngcontent-%COMP%]{background-color:#f4f4f4}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]:hover{background-color:#efefef}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{display:flex}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{line-height:1.5}.dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]:hover, .dropdown-wrapper[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]   .item.active[_ngcontent-%COMP%]{font-weight:bold;text-decoration:none;background-color:#f4f4f4}"], changeDetection: 0 });
DropdownComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
DropdownComponent.propDecorators = {
    baseItemComponent: [{ type: ContentChildren, args: [BaseItemComponent,] }],
    bic: [{ type: ViewChild, args: [BaseItemComponent, { read: false, static: false },] }],
    updateSelectedFilters: [{ type: Output }],
    updateSelectedFiltersAndXOr: [{ type: Output }],
    applyFilters: [{ type: Output }],
    clearFilters: [{ type: Output }],
    title: [{ type: Input }],
    icon: [{ type: Input }],
    type: [{ type: Input }],
    operator: [{ type: Input }],
    parentId: [{ type: Input }],
    toggleDropdown: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-dropdown',
                template: "<div class=\"dropdown-wrapper\" [ngClass]=\"type\">\n  <div class=\"selected\" [ngClass]=\"{ 'open': dropdown }\">\n    <span class=\"name\" [innerHTML]=\"title\"></span>\n    <span class=\"dropdown-icon\" [ngClass]=\"{'icon-open': dropdown, 'icon-close': !dropdown }\">\n      </span>\n  </div>\n  <div class=\"dropdown\" *ngIf=\"dropdown\">\n    <div class=\"some\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"button-wrapper p-0\">\n      <div class=\"button col-6 parentId clear\" (click)=\"clear()\">Clear</div>\n      <div class=\"button apply col-6\" (click)=\"apply()\">Apply</div>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host.sns-dropdown-item{border-radius:0;background-color:#fff;color:#000;border:1px solid #000000;margin-left:20px}:host.sns-dropdown-item.first{margin:0}:host.sns-dropdown-item.mobile.first{margin-left:20px}:host.sns-dropdown-item:not(.mobile) .dropdown{box-shadow:0 0 10px #00000026;padding:10px 0 20px;background-color:#fff;position:absolute;width:auto;top:50px;left:0;z-index:9999999;min-width:250px}:host.sns-dropdown-item.mobile{border:solid .5px rgba(167,167,168,.75);border-top:0;border-right:0}:host.sns-dropdown-item.mobile .dropdown-wrapper{display:flex;flex-direction:column;align-items:flex-start}:host.sns-dropdown-item.mobile .dropdown-wrapper.classic{background:none;padding-right:0;padding-left:0;padding-bottom:0}:host.sns-dropdown-item.mobile .dropdown-wrapper .selected{padding-bottom:15px}:host.sns-dropdown-item.mobile .dropdown-wrapper .dropdown{width:100%}.dropdown-wrapper{background-color:#fff;justify-content:center;align-items:center;position:relative;cursor:pointer;display:flex;height:100%;width:100%;padding:9px 20px}.dropdown-wrapper.classic .selected{background:url(/assets/arrow-down-black.svg) 95% center no-repeat}.dropdown-wrapper.classic .selected.open{background:url(/assets/arrow-up-black.svg) 95% center no-repeat}.dropdown-wrapper .selected{justify-content:space-between;align-items:center;display:flex;height:31px;padding:6px 14px;width:100%;position:relative;z-index:0}.dropdown-wrapper .selected img{height:20px;width:20px}.dropdown-wrapper .selected .name{line-height:1.5;letter-spacing:normal}.dropdown-wrapper .selected .dropdown-icon{background-repeat:no-repeat;height:6px;width:8px}.dropdown-wrapper .dropdown .some{border-bottom:solid 1px rgba(0,0,0,.05);padding-left:14px}.dropdown-wrapper .dropdown .select-info{display:flex;justify-content:space-between;padding:2px 16px}.dropdown-wrapper .dropdown .button-wrapper{display:flex}.dropdown-wrapper .dropdown .button-wrapper .button{text-align:center;padding:10px 16px}.dropdown-wrapper .dropdown .button-wrapper .button.apply{background-color:#f4f4f4}.dropdown-wrapper .dropdown .button-wrapper .button:hover{background-color:#efefef}.dropdown-wrapper .dropdown .item{display:flex}.dropdown-wrapper .dropdown .item .title{line-height:1.5}.dropdown-wrapper .dropdown .item:hover,.dropdown-wrapper .dropdown .item.active{font-weight:bold;text-decoration:none;background-color:#f4f4f4}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { updateSelectedFilters: [{
            type: Output
        }], updateSelectedFiltersAndXOr: [{
            type: Output
        }], applyFilters: [{
            type: Output
        }], clearFilters: [{
            type: Output
        }], toggleDropdown: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], baseItemComponent: [{
            type: ContentChildren,
            args: [BaseItemComponent]
        }], bic: [{
            type: ViewChild,
            args: [BaseItemComponent, { read: false, static: false }]
        }], title: [{
            type: Input
        }], icon: [{
            type: Input
        }], type: [{
            type: Input
        }], operator: [{
            type: Input
        }], parentId: [{
            type: Input
        }] }); })();

// @dynamic
class FiltersComponent {
    constructor(filterService, platformId) {
        this.filterService = filterService;
        this.platformId = platformId;
        this.filters = [];
        this.categoryFilters = [];
        this.level = '';
        this.filterValue = new EventEmitter();
        this.filterWithChildren = [];
        this.selectedFilters = [];
        this.isAll = true;
        this.btnClick = 'click';
        this.and = FilterCategoryOperationEnum.AND;
        this.idToNameFilterMap = new Map();
        this.selectedFiltersAndXOr = [];
        this.isBrowser = true;
        this.isFilterOpen = false;
    }
    ngOnInit() {
        this.detectScreenSize();
        console.log('Filter');
        /** No history!!!! */
        localStorage.setItem(LSK.SELECTED_FILTERS, '[]');
        localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, '[]');
        this.filters.forEach((f) => {
            if (f.children.length > 0) {
                this.filterWithChildren.push(f);
            }
        });
        this.setFiltersMap();
    }
    onResize() {
        this.detectScreenSize();
    }
    selectFilter(click, filter) {
        if (filter == '-1') {
            this.isAll = true;
            this.selectedFilters = [];
            this.filters.forEach((f) => {
                f.checked = false;
            });
        }
        else {
            filter.checked = !filter.checked;
            this.isAll = false;
            this.btnClick = click;
            if (filter.checked) {
                this.selectedFilters.push(filter.id);
            }
            else {
                this.selectedFilters = this.selectedFilters.filter(item => item !== filter.id);
            }
        }
        let query = this.filterService.createElasticQuery(this.categoryFilters, this.selectedFilters, this.categoryOperation, this.filterOperation);
        this.filterValue.emit(query);
    }
    updateSelectedFilters(event) {
        this.selectedFilters = event;
    }
    updateSelectedFiltersAndXOr(event) {
        this.selectedFiltersAndXOr = event;
    }
    removeSelectedFilters(event) {
    }
    applySelectedFilters() {
        return __awaiter(this, void 0, void 0, function* () {
            if (FiltersService.isTwoLevelMixOperation(this.filterOperation)) {
                this.sendValue(this.selectedFiltersAndXOr);
            }
            else {
                this.sendValue(this.selectedFilters);
            }
            this.isFilterOpen = false;
        });
    }
    clearFilters() {
        return __awaiter(this, void 0, void 0, function* () {
            let jsonANDxOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
            this.sendValue(jsonANDxOr);
        });
    }
    clearAll() {
        return __awaiter(this, void 0, void 0, function* () {
            this.children.forEach((dp) => {
                dp.clearAllFilter();
            });
            this.selectedFilters = [];
            this.selectedFiltersAndXOr = [];
            this.sendValue([]);
        });
    }
    removeFilter(sf) {
        return __awaiter(this, void 0, void 0, function* () {
            this.children.forEach((dp) => {
                dp.clearFilter(sf);
            });
            if (FiltersService.isTwoLevelMixOperation(this.filterOperation)) {
                this.updateFilterAndXOr(sf);
            }
        });
    }
    setFiltersMap() {
        for (const f of this.filters) {
            for (const child of f.children) {
                this.idToNameFilterMap.set(child.id, child);
            }
        }
    }
    updateFilterAndXOr(deleteNumber) {
        let jsonANDxOr = JSON.parse(localStorage.getItem(LSK.SELECTED_FILTERS_AND_X_OR) || '[]');
        jsonANDxOr.forEach((elem, i) => {
            if (elem.children.length > 0) {
                elem.children.forEach((element, index) => {
                    // @ts-ignore
                    if (element == deleteNumber)
                        elem.children.splice(index, 1);
                });
                if (elem.children.length == 0) {
                    jsonANDxOr.splice(i, 1);
                }
            }
        });
        localStorage.setItem(LSK.SELECTED_FILTERS_AND_X_OR, JSON.stringify(jsonANDxOr));
        this.sendValue(jsonANDxOr);
    }
    sendValue(json) {
        let query = this.filterService.createElasticQuery(this.categoryFilters, json, this.categoryOperation, this.filterOperation);
        this.filterValue.emit(query);
    }
    detectScreenSize() {
        if (!isPlatformBrowser(this.platformId)) {
            this.isBrowser = false;
            return;
        }
        this.isMobileResolution = window.innerWidth < 768;
        if (!this.isMobileResolution) {
            this.isFilterOpen = false;
        }
    }
    openFilter($event) {
        this.isFilterOpen = true;
        window.scroll(0, 0);
    }
    closeFilter($event) {
        this.isFilterOpen = false;
    }
    apply() {
        console.log('ddd');
        /*this.childrenElement.toArray().forEach((c:any, index: number) => {
            this.children!.get(index)!.apply();
        });*/
    }
}
FiltersComponent.ɵfac = function FiltersComponent_Factory(t) { return new (t || FiltersComponent)(ɵngcc0.ɵɵdirectiveInject(FiltersService), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
FiltersComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FiltersComponent, selectors: [["lib-filters"]], viewQuery: function FiltersComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DropdownComponent, 1, false);
        ɵngcc0.ɵɵviewQuery(DropdownComponent, 1, false);
        ɵngcc0.ɵɵviewQuery(DropdownComponent, 1);
        ɵngcc0.ɵɵviewQuery(DropdownComponent, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dp = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.children = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.childrenElement = _t);
    } }, hostBindings: function FiltersComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function FiltersComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { filters: "filters", categoryFilters: "categoryFilters", level: "level", filterOperation: "filterOperation", categoryOperation: "categoryOperation" }, outputs: { filterValue: "filterValue" }, decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["level2", ""], ["level1", ""], [3, "ngIf", "ngIfElse"], ["desktop", ""], [4, "ngIf"], ["class", "filters level2 mobile", 4, "ngIf"], [1, "filters", "level2", "mobile"], [1, "filter-container-btn", "d-flex", "justify-content-evenly", "align-items-center", "w-100", 3, "click"], [1, "shape"], [1, "filter-wrapper", 3, "ngClass"], [1, "d-flex", "flex-column", "filter-wrapper-column"], [1, "filter-mobile-clear-close", "d-flex", "justify-content-between"], [1, "filter-mobile-clear"], [1, "filter-mobile-close-con", "d-flex", "align-items-center", "justify-content-center", 3, "click"], [1, "filter-mobile-close"], [4, "ngFor", "ngForOf"], [1, "filter-bottom", "d-flex", "align-items-end"], [3, "class", "ngClass", "title", "icon", "type", "operator", "parentId", "updateSelectedFilters", "updateSelectedFiltersAndXOr", "applyFilters", "clearFilters", 4, "ngIf"], [3, "ngClass", "title", "icon", "type", "operator", "parentId", "updateSelectedFilters", "updateSelectedFiltersAndXOr", "applyFilters", "clearFilters"], ["dropdown", ""], [3, "class", "parentId", "dropdown", "id", "name", "slug", "checked", "index", "ngClass", 4, "ngFor", "ngForOf"], [3, "parentId", "dropdown", "id", "name", "slug", "checked", "index", "ngClass"], ["class", "filters level2", 4, "ngIf"], [1, "filters", "level2"], [1, "filter-wrapper"], [1, "d-flex"], [1, "title"], [1, "selected-filters", "d-flex", "flex-wrap"], [1, "p-2", "reset", 3, "click"], [1, "filter"], ["src", "/assets/reset-filter-black.svg", 1, "remove-filters"], [3, "innerHTML"], ["src", "/assets/x.svg", 1, "remove-filter", 3, "click"], ["class", "filters level1 ", 4, "ngIf"], [1, "filters", "level1"], ["class", "filter-item ", "data-id", "-1", 3, "ngClass", "click", 4, "ngIf"], ["class", "filter-item", 3, "id", "ngClass", "click", 4, "ngFor", "ngForOf"], ["data-id", "-1", 1, "filter-item", 3, "ngClass", "click"], [1, "filter-name"], [1, "filter-item", 3, "id", "ngClass", "click"]], template: function FiltersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FiltersComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FiltersComponent_ng_template_1_Template, 4, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, FiltersComponent_ng_template_3_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.level === "Level2")("ngIfThen", _r1)("ngIfElse", _r3);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc2.NgForOf, DropdownComponent, BaseItemComponent], styles: [".filters[_ngcontent-%COMP%]{display:flex}.filters.level1[_ngcontent-%COMP%]{align-items:start;background-color:#006d7a}.filters.level1[_ngcontent-%COMP%]   .filter-item[_ngcontent-%COMP%]{padding:10px 20px;color:#fff;cursor:pointer;border-right:1px solid #FFFFFF}.filters.level1[_ngcontent-%COMP%]   .filter-item.active[_ngcontent-%COMP%]{background-color:#113d44;color:#f8b827}.filters.level2[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]{display:none}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-container-btn[_ngcontent-%COMP%]{border:1px solid #c9c9c9;border-radius:4px;height:40px;cursor:pointer}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-container-btn[_ngcontent-%COMP%]   .shape[_ngcontent-%COMP%]{background:url(/assets/filter.svg) 95% center no-repeat;width:24px;height:24px}.filters.level2.mobile[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%]{display:none}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]{position:absolute;z-index:999;height:100vh;top:0;left:0;background-color:#0006;width:100%}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-wrapper-column[_ngcontent-%COMP%]{height:100%}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-mobile-clear-close[_ngcontent-%COMP%]{height:74px;min-height:74px;margin-left:20px;background-color:#fff;border:solid .5px rgba(167,167,168,.75);border-top:0;border-right:0}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-mobile-clear-close[_ngcontent-%COMP%]   .filter-mobile-clear[_ngcontent-%COMP%]{width:calc(100% - 75px);display:inline-block}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-mobile-clear-close[_ngcontent-%COMP%]   .filter-mobile-close-con[_ngcontent-%COMP%]{width:75px;cursor:pointer;border-left:solid .5px rgba(167,167,168,.7)}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-mobile-clear-close[_ngcontent-%COMP%]   .filter-mobile-close-con[_ngcontent-%COMP%]   .filter-mobile-close[_ngcontent-%COMP%]{background:url(/assets/big-x.svg) 95% center no-repeat;width:24px;height:24px}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-bottom[_ngcontent-%COMP%]{background-color:#fff;height:100%;margin-left:20px}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-bottom[_ngcontent-%COMP%]   .filter-bottom-ph[_ngcontent-%COMP%]{height:92px;border-top:solid .5px rgba(167,167,168,.75);width:100%}.filters.level2.mobile[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-bottom[_ngcontent-%COMP%]   .filter-bottom-ph.show[_ngcontent-%COMP%]   .filter-bottom-pn-apply[_ngcontent-%COMP%]{width:100%;margin:20px;text-align:center;background:black;vertical-align:middle;padding:14px;color:#fff}.selected-filters[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]{padding:5px 20px;border:1px solid #000000;display:flex}.selected-filters[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-right:10px}.selected-filters[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]   .remove-filter[_ngcontent-%COMP%]{cursor:pointer}.selected-filters[_ngcontent-%COMP%]   .reset[_ngcontent-%COMP%]{cursor:pointer}"] });
FiltersComponent.ctorParameters = () => [
    { type: FiltersService },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
FiltersComponent.propDecorators = {
    dropdownComponent: [{ type: ViewChild, args: [DropdownComponent, { read: false, static: false },] }],
    children: [{ type: ViewChildren, args: [DropdownComponent,] }],
    dp: [{ type: ViewChild, args: [DropdownComponent, { read: false, static: false },] }],
    childrenElement: [{ type: ViewChildren, args: [DropdownComponent,] }],
    filters: [{ type: Input }],
    categoryFilters: [{ type: Input }],
    level: [{ type: Input }],
    filterOperation: [{ type: Input }],
    categoryOperation: [{ type: Input }],
    filterValue: [{ type: Output }],
    onResize: [{ type: HostListener, args: ['window:resize', [],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FiltersComponent, [{
        type: Component,
        args: [{
                selector: 'lib-filters',
                template: "<div *ngIf=\"level === 'Level2'; then level2 else level1\">\r\n</div>\r\n\r\n<ng-template #level2>\r\n\r\n  <ng-template [ngIf]=\"isMobileResolution\" [ngIfElse]=\"desktop\">\r\n    <div class=\"filters level2 mobile\" *ngIf=\"filterWithChildren.length >0\">\r\n      <div class=\"filter-container-btn d-flex justify-content-evenly align-items-center w-100\" (click)=\"openFilter($event)\">\r\n        <span class=\"shape\"></span>\r\n        <span>Filter</span>\r\n      </div>\r\n      <div class=\"filter-wrapper\" [ngClass]=\"isFilterOpen?'':'hidden'\">\r\n        <div class=\"d-flex flex-column filter-wrapper-column \">\r\n          <div class=\"filter-mobile-clear-close d-flex justify-content-between\">\r\n            <span class=\"filter-mobile-clear\"></span>\r\n            <span class=\"filter-mobile-close-con d-flex align-items-center justify-content-center\" (click)=\"closeFilter($event)\">\r\n              <span class=\"filter-mobile-close\" ></span>\r\n            </span>\r\n          </div>\r\n          <ng-container *ngFor=\"let filter of filterWithChildren; let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\">\r\n            <lib-dropdown *ngIf=\"filter.children!.length>0\"\r\n              #dropdown\r\n              class=\"sns-dropdown-item sns-dropdown-item-{{i}}\"\r\n              [ngClass]=\"[filter.children!.length>0?'show':'disabled', isMobileResolution?'mobile':'',isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'']\"\r\n              [title]=\"filter.name\"\r\n              [icon]=\"filter.icon\"\r\n              [type]=\"'classic'\"\r\n              [operator]=\"filterOperation\"\r\n              [parentId]=\"filter.id\"\r\n              (updateSelectedFilters)=\"updateSelectedFilters($event)\"\r\n              (updateSelectedFiltersAndXOr)=\"updateSelectedFiltersAndXOr($event)\"\r\n              (applyFilters)=\"applySelectedFilters()\"\r\n              (clearFilters)=\"clearFilters()\">\r\n              <lib-base-item\r\n                  *ngFor=\"let f of filter.children; let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\"\r\n                  class=\"item item-{{i}}\"\r\n                  [parentId]=\"filter.id\"\r\n                  [dropdown]=\"dropdown\"\r\n                  [id]=\"f.id\"\r\n                  [name]=\"f.name\"\r\n                  [slug]=\"f.id +''\"\r\n                  [checked]=\"f.checked\"\r\n                  [index]=\"i\"\r\n                  [ngClass]=\"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'']\"\r\n              >\r\n              </lib-base-item>\r\n            </lib-dropdown>\r\n          </ng-container>\r\n          <div class=\"filter-bottom  d-flex align-items-end\">\r\n          <!-- <div class=\"filter-bottom-ph d-flex justify-content-center align-items-center show\" (click)=\"apply()\" >\r\n              <div class=\"filter-bottom-pn-apply\">Apply Filter</div>\r\n            </div>-->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #desktop>\r\n    <div class=\"filters level2\" *ngIf=\"filterWithChildren.length > 0\">\r\n      <div class=\"filter-wrapper\">\r\n        <div class=\"d-flex\">\r\n          <ng-container *ngFor=\"let filter of filterWithChildren; let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\">\r\n            <lib-dropdown *ngIf=\"filter.children!.length>0\"\r\n              #dropdown\r\n              class=\"sns-dropdown-item sns-dropdown-item-{{i}}\"\r\n              [ngClass]=\"[filter.children!.length>0?'show':'disabled',isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'']\"\r\n              [title]=\"filter.name\"\r\n              [icon]=\"filter.icon\"\r\n              [type]=\"'classic'\"\r\n              [operator]=\"filterOperation\"\r\n              [parentId]=\"filter.id\"\r\n              (updateSelectedFilters)=\"updateSelectedFilters($event)\"\r\n              (updateSelectedFiltersAndXOr)=\"updateSelectedFiltersAndXOr($event)\"\r\n              (applyFilters)=\"applySelectedFilters()\"\r\n              (clearFilters)=\"clearFilters()\">\r\n              <lib-base-item\r\n                  *ngFor=\"let f of filter.children; let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\"\r\n                  class=\"item item-{{i}}\"\r\n                  [parentId]=\"filter.id\"\r\n                  [dropdown]=\"dropdown\"\r\n                  [id]=\"f.id\"\r\n                  [name]=\"f.name\"\r\n                  [slug]=\"f.id +''\"\r\n                  [checked]=\"f.checked\"\r\n                  [index]=\"i\"\r\n                  [ngClass]=\"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'']\"\r\n              >\r\n              </lib-base-item>\r\n            </lib-dropdown>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n\r\n\r\n  <ng-container *ngIf=\"selectedFilters! && selectedFilters!.length > 0\">\r\n    <div class=\"title\">Applied filters</div>\r\n    <div class=\"selected-filters d-flex flex-wrap\">\r\n      <div *ngFor=\"let filterId of selectedFilters\" >\r\n        <div class=\"filter\">\r\n          <span [innerHTML]=\"idToNameFilterMap.get(filterId)?.name\"></span>\r\n          <img src=\"/assets/x.svg\" class=\"remove-filter\" (click)=\"removeFilter(filterId)\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"p-2 reset\" (click)=\"clearAll()\">\r\n        <div class=\"filter\">\r\n          Reset filter\r\n          <img src=\"/assets/reset-filter-black.svg\" class=\"remove-filters\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n\r\n\r\n<ng-template #level1>\r\n  <div class=\"filters level1 \" *ngIf=\"filters.length > 0\">\r\n    <span *ngIf=\"filterOperation != and\" class=\"filter-item \" data-id=\"-1\" (click)=\"selectFilter('click', '-1')\" [ngClass]=\"[isAll?'active':'' ]\">\r\n      <span class=\"filter-name\">All</span>\r\n    </span>\r\n    <span class=\"filter-item\"\r\n          *ngFor=\"let filter of filters; index as i; first as isFirst; last as isLast; odd as isOdd; even as isEven\"\r\n          data-id=\"{{filter.id}}\"\r\n          (click)=\"selectFilter('click'+i, filter)\"\r\n          [ngClass]=\"[filter.checked?'active':'', isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'' ]\" >\r\n      <span class=\"filter-name\" >{{filter.name}}</span>\r\n    </span>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [".filters{display:flex}.filters.level1{align-items:start;background-color:#006d7a}.filters.level1 .filter-item{padding:10px 20px;color:#fff;cursor:pointer;border-right:1px solid #FFFFFF}.filters.level1 .filter-item.active{background-color:#113d44;color:#f8b827}.filters.level2 .disabled{display:none}.filters.level2.mobile .filter-container-btn{border:1px solid #c9c9c9;border-radius:4px;height:40px;cursor:pointer}.filters.level2.mobile .filter-container-btn .shape{background:url(/assets/filter.svg) 95% center no-repeat;width:24px;height:24px}.filters.level2.mobile .hidden{display:none}.filters.level2.mobile .filter-wrapper{position:absolute;z-index:999;height:100vh;top:0;left:0;background-color:#0006;width:100%}.filters.level2.mobile .filter-wrapper .filter-wrapper-column{height:100%}.filters.level2.mobile .filter-wrapper .filter-mobile-clear-close{height:74px;min-height:74px;margin-left:20px;background-color:#fff;border:solid .5px rgba(167,167,168,.75);border-top:0;border-right:0}.filters.level2.mobile .filter-wrapper .filter-mobile-clear-close .filter-mobile-clear{width:calc(100% - 75px);display:inline-block}.filters.level2.mobile .filter-wrapper .filter-mobile-clear-close .filter-mobile-close-con{width:75px;cursor:pointer;border-left:solid .5px rgba(167,167,168,.7)}.filters.level2.mobile .filter-wrapper .filter-mobile-clear-close .filter-mobile-close-con .filter-mobile-close{background:url(/assets/big-x.svg) 95% center no-repeat;width:24px;height:24px}.filters.level2.mobile .filter-wrapper .filter-bottom{background-color:#fff;height:100%;margin-left:20px}.filters.level2.mobile .filter-wrapper .filter-bottom .filter-bottom-ph{height:92px;border-top:solid .5px rgba(167,167,168,.75);width:100%}.filters.level2.mobile .filter-wrapper .filter-bottom .filter-bottom-ph.show .filter-bottom-pn-apply{width:100%;margin:20px;text-align:center;background:black;vertical-align:middle;padding:14px;color:#fff}.selected-filters .filter{padding:5px 20px;border:1px solid #000000;display:flex}.selected-filters .filter span{padding-right:10px}.selected-filters .filter .remove-filter{cursor:pointer}.selected-filters .reset{cursor:pointer}\n"]
            }]
    }], function () { return [{ type: FiltersService }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { filters: [{
            type: Input
        }], categoryFilters: [{
            type: Input
        }], level: [{
            type: Input
        }], filterValue: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', []]
        }], dropdownComponent: [{
            type: ViewChild,
            args: [DropdownComponent, { read: false, static: false }]
        }], children: [{
            type: ViewChildren,
            args: [DropdownComponent]
        }], dp: [{
            type: ViewChild,
            args: [DropdownComponent, { read: false, static: false }]
        }], childrenElement: [{
            type: ViewChildren,
            args: [DropdownComponent]
        }], filterOperation: [{
            type: Input
        }], categoryOperation: [{
            type: Input
        }] }); })();

const components = [
    FiltersComponent
];
class FiltersModule {
}
FiltersModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FiltersModule });
FiltersModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FiltersModule_Factory(t) { return new (t || FiltersModule)(); }, imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FiltersModule, { declarations: function () { return [FiltersComponent, DropdownComponent, BaseItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [FiltersComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FiltersModule, [{
        type: NgModule,
        args: [{
                declarations: [...components, DropdownComponent, BaseItemComponent],
                imports: [
                    CommonModule,
                    FormsModule
                ],
                exports: [...components]
            }]
    }], null, null); })();

/*
 * Public API Surface of filters
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Bool, CategoryOperationEnum, Filter, FilterCategoryOperationEnum, FilterDropdown, FilterValue, FilterValueChild, FiltersComponent, FiltersModule, FiltersService, JsonFilter, JsonFilterChild, LSK, Match, MatchCategory, Query, DropdownComponent as ɵa, BaseItemComponent as ɵb };

//# sourceMappingURL=scoop-lli-filters.js.map